/* src/app/components/dialogs/quick-link-management/quick-link-management.component.scss */
.container {
  min-height: 150px;
  max-height: 300px;
  border: solid 2px #ccc;
  border-radius: 4px;
}
:host-context(.dark-theme) .container {
  border: solid 2px #656565;
}
.header {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  width: 100%;
  justify-content: flex-start;
}
.header-text {
  text-align: left;
  width: 60%;
  padding-left: 5px;
}
.header-check {
  padding-left: 10px;
}
.child {
  justify-content: center;
}
.child-check {
  width: 10%;
}
.child-text {
  width: 70%;
  padding-left: 12px;
}
.child-icon {
  padding-left: 10px;
}
mat-form-field {
  width: 350px;
}
.ddl-label {
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .ddl-label {
  color: rgba(255, 255, 255, 0.54);
}
td {
  padding-left: 20px;
}
/*# sourceMappingURL=quick-link-management.component.css.map */
